export default __webpack_public_path__ + "static/media/share-arrow.0869edf7.svg";